import React from 'react';
import { Panel } from '../types';

interface PanelSummaryProps {
  walls: {
    left: Panel[];
    right: Panel[];
    top: Panel[];
    bottom: Panel[];
  };
}

const PanelSummary: React.FC<PanelSummaryProps> = ({ walls }) => {
  // 패널 수량 집계
  const summary: { [size: number]: { count: number; isCustom: boolean } } = {};
  let totalCount = 0;

  Object.entries(walls).forEach(([side, panels]) => {
    panels.forEach(panel => {
      totalCount++;
      if (summary[panel.size]) {
        summary[panel.size].count++;
      } else {
        summary[panel.size] = { count: 1, isCustom: panel.isCustom };
      }
    });
  });

  const sorted = Object.entries(summary)
    .map(([size, info]) => ({ size: Number(size), ...info }))
    .sort((a, b) => b.size - a.size);

  const sideNames: { [key: string]: string } = {
    top: '상단', bottom: '하단', left: '좌측', right: '우측'
  };

  return (
    <div className="pd-card" style={{ marginTop: 10 }}>
      <h3 className="pd-title">패널 수량 <small>벽 · 칸막이</small></h3>
      <table className="pd-table">
        <thead><tr><th>사이즈</th><th style={{ textAlign: 'right' }}>수량</th><th style={{ textAlign: 'right' }}>구분</th></tr></thead>
        <tbody>
          {sorted.map(item => (
            <tr key={item.size}>
              <td>{item.size}mm</td>
              <td style={{ textAlign: 'right' }}>{item.count}장</td>
              <td style={{ textAlign: 'right', color: item.isCustom ? 'var(--pd-orange)' : 'var(--pd-blue)' }}>{item.isCustom ? '재단' : '표준'}</td>
            </tr>
          ))}
          <tr className="sum"><td>합계</td><td style={{ textAlign: 'right' }}>{totalCount}장</td><td></td></tr>
        </tbody>
      </table>
      <div style={{ marginTop: 14 }}>
        {Object.entries(walls).map(([side, panels]) => (
          <div key={side} className="pd-hint" style={{ marginBottom: 6 }}>
            <b style={{ color: 'var(--pd-sub)' }}>{sideNames[side]} {panels.length}장</b> · {panels.map(p => p.size).join(' + ')}
          </div>
        ))}
      </div>
    </div>
  );
};



export default PanelSummary;
